(() => {
    "use strict";

    const slider = document.querySelector(
        "[data-home-minimal-book-slider]"
    );

    if (!slider) {
        return;
    }

    const previousButton = document.querySelector(
        "[data-home-minimal-book-slider-prev]"
    );

    const nextButton = document.querySelector(
        "[data-home-minimal-book-slider-next]"
    );

    const catalog =
        window.frBooksCatalog;

    const itemCatalog =
        window.frItemCatalog ||
        null;

    if (!catalog) {
        console.error(
            "frBooksCatalog must load before the home book slider."
        );

        return;
    }

    const EDGE_TOLERANCE =
        2;

    const RECENT_WORK_DAYS =
        14;

    const RECENT_WORK_MS =
        RECENT_WORK_DAYS *
        24 *
        60 *
        60 *
        1000;

    const GENERIC_COVER_IMAGE_URL =
        "/assets/images/covers/cover_genericBg1.png";


    // ==========================================================
    // BOOK METADATA
    // ==========================================================

    function parseBookDescription(
        description
    ) {
        const values =
            {};

        String(
            description ||
            ""
        )
            .replace(
                /\r\n?/g,
                "\n"
            )
            .split(
                "\n"
            )
            .forEach(
                (line) => {
                    const match =
                        line.match(
                            /^\s*([a-zA-Z][a-zA-Z0-9]*)\s*:\s*(.*?)\s*$/
                        );

                    if (
                        match
                    ) {
                        values[
                            match[1]
                            ] =
                            match[2];
                    }
                }
            );

        return values;
    }


    function getWorkingTitle(
        book
    ) {
        return String(
                book?.tagName ||
                book?.title ||
                "Book"
            )
                .replace(
                    /^(?:FamBook|Book):\s*/i,
                    ""
                )
                .trim() ||
            "Book";
    }


    function getStructuredMetadata(
        book
    ) {
        const parsed =
            parseBookDescription(
                book?.description ||
                ""
            );

        return {
            ...parsed,

            type:
                book?.type ||
                parsed.type ||
                "",

            subtitle:
                book?.subtitle ||
                parsed.subtitle ||
                "",

            estimatedPages:
                book?.estimatedPages ??
                parsed.estimatedPages ??
                "",

            summary:
                book?.summary ||
                parsed.summary ||
                "",

            coverImage:
                book?.coverImage ||
                parsed.coverImage ||
                "",

            catalogAccess:
                book?.catalogAccess ||
                parsed.catalogAccess ||
                ""
        };
    }


    // ==========================================================
    // BOOK ITEMS
    // ==========================================================

    function normalizeBookSlug(
        value
    ) {
        return String(
            value ||
            ""
        )
            .trim()
            .replace(
                /^hash-/i,
                ""
            );
    }


    function getItemsForBook(
        bookSlug
    ) {
        if (
            !itemCatalog ||
            typeof itemCatalog.getItems !==
            "function"
        ) {
            return [];
        }

        const normalizedBookSlug =
            normalizeBookSlug(
                bookSlug
            );

        return itemCatalog
            .getItems()
            .filter(
                (item) =>
                    normalizeBookSlug(
                        item?.bookSlug
                    ) ===
                    normalizedBookSlug
            );
    }


    function getCurrentPageCount(
        bookSlug
    ) {
        if (
            !itemCatalog ||
            typeof itemCatalog.getItems !==
            "function"
        ) {
            return null;
        }

        let total =
            0;

        getItemsForBook(
            bookSlug
        ).forEach(
            (item) => {
                const pageCount =
                    Number(
                        item?.pageCount
                    );

                if (
                    Number.isFinite(
                        pageCount
                    ) &&
                    pageCount > 0
                ) {
                    total +=
                        pageCount;
                }
            }
        );

        return total;
    }


    // ==========================================================
    // RECENT WORK
    // ==========================================================

    function getBookLastWorkedAt(
        bookSlug
    ) {
        let latestTimestamp =
            null;

        getItemsForBook(
            bookSlug
        ).forEach(
            (item) => {
                const dateText =
                    item?.updatedAt ||
                    item?.publishedAt ||
                    "";

                if (
                    !dateText
                ) {
                    return;
                }

                const timestamp =
                    new Date(
                        dateText
                    ).getTime();

                if (
                    !Number.isFinite(
                        timestamp
                    )
                ) {
                    return;
                }

                if (
                    latestTimestamp ===
                    null ||
                    timestamp >
                    latestTimestamp
                ) {
                    latestTimestamp =
                        timestamp;
                }
            }
        );

        return latestTimestamp;
    }


    function wasBookWorkedOnRecently(
        bookSlug
    ) {
        const lastWorkedAt =
            getBookLastWorkedAt(
                bookSlug
            );

        if (
            lastWorkedAt ===
            null
        ) {
            return false;
        }

        const age =
            Date.now() -
            lastWorkedAt;

        return (
            age >=
            0 &&
            age <=
            RECENT_WORK_MS
        );
    }


    function createRecentWorkBadge() {
        const badge =
            document.createElement(
                "div"
            );

        badge.className =
            "fr-home-minimal-bookSlider-book__recentBadge";

        badge.textContent =
            "FRESH";

        badge.title =
            `Worked on within the past ${RECENT_WORK_DAYS} days`;

        badge.setAttribute(
            "aria-hidden",
            "true"
        );

        Object.assign(
            badge.style,
            {
                position:
                    "absolute",

                right:
                    "0.7rem",

                top:
                    "0.7rem",

                zIndex:
                    "4",

                display:
                    "inline-flex",

                alignItems:
                    "center",

                justifyContent:
                    "center",

                minWidth:
                    "4.8rem",

                padding:
                    "0.5rem 0.8rem 0.44rem",

                border:
                    "1px solid rgba(255, 255, 255, 0.8)",

                borderRadius:
                    "0.6rem",

                background:
                    "rgba(50, 116, 62, 0.95)",

                color:
                    "#fff4d8",

                fontFamily:
                    "Arial, Helvetica, sans-serif",

                fontSize:
                    "0.88rem",

                fontWeight:
                    "800",

                lineHeight:
                    "1",

                letterSpacing:
                    "0.13em",

                textTransform:
                    "uppercase",

                whiteSpace:
                    "nowrap",

                boxShadow:
                    "0 0.2rem 0.45rem rgba(0, 0, 0, 0.3)",

                pointerEvents:
                    "none"
            }
        );

        return badge;
    }


    // ==========================================================
    // COMPLETION
    // ==========================================================

    function getCompletionPercentage(
        book,
        structuredMetadata = null
    ) {
        const metadata =
            structuredMetadata ||
            getStructuredMetadata(
                book
            );

        const estimatedPages =
            Number(
                metadata.estimatedPages
            );

        const currentPages =
            getCurrentPageCount(
                book.slug
            );

        if (
            !Number.isFinite(
                estimatedPages
            ) ||
            estimatedPages <=
            0 ||
            currentPages ===
            null
        ) {
            return null;
        }

        return Math.max(
            0,
            Math.min(
                100,
                Math.round(
                    (
                        currentPages /
                        estimatedPages
                    ) *
                    100
                )
            )
        );
    }


    // ==========================================================
    // SORTING
    // ==========================================================

    function compareWorkingTitles(
        firstBook,
        secondBook
    ) {
        return getWorkingTitle(
            firstBook
        ).localeCompare(
            getWorkingTitle(
                secondBook
            ),
            undefined,
            {
                sensitivity:
                    "base"
            }
        );
    }


    function compareBooksByProgress(
        firstBook,
        secondBook
    ) {
        const firstCompletion =
            getCompletionPercentage(
                firstBook
            );

        const secondCompletion =
            getCompletionPercentage(
                secondBook
            );

        const firstHasCompletion =
            firstCompletion !==
            null;

        const secondHasCompletion =
            secondCompletion !==
            null;

        if (
            firstHasCompletion &&
            !secondHasCompletion
        ) {
            return -1;
        }

        if (
            !firstHasCompletion &&
            secondHasCompletion
        ) {
            return 1;
        }

        if (
            firstHasCompletion &&
            secondHasCompletion &&
            firstCompletion !==
            secondCompletion
        ) {
            return (
                secondCompletion -
                firstCompletion
            );
        }

        return compareWorkingTitles(
            firstBook,
            secondBook
        );
    }


    // ==========================================================
    // PERMANENT ID
    // ==========================================================

    function normalizePermanentIdSlug(
        value
    ) {
        let slug =
            String(
                value ||
                ""
            )
                .trim()
                .toLowerCase();

        let previousSlug =
            null;

        while (
            slug &&
            slug !==
            previousSlug
            ) {
            previousSlug =
                slug;

            slug =
                slug
                    .replace(
                        /^hash-/,
                        ""
                    )
                    .replace(
                        /^family-book-/,
                        ""
                    )
                    .replace(
                        /^fambook-/,
                        ""
                    )
                    .replace(
                        /^book-/,
                        ""
                    );
        }

        return slug;
    }


    function getPermanentBookId(
        book
    ) {
        return normalizePermanentIdSlug(
            book?.slug
        )
            .split(
                "-"
            )
            .filter(
                Boolean
            )
            .join(
                "-"
            )
            .toUpperCase();
    }


    function setPermanentIdPresentation(
        element,
        isMetadataMode
    ) {
        if (
            !element
        ) {
            return;
        }

        if (
            isMetadataMode
        ) {
            Object.assign(
                element.style,
                {
                    fontFamily:
                        "Arial, Helvetica, sans-serif",

                    fontSize:
                        "0.95rem",

                    fontWeight:
                        "600",

                    lineHeight:
                        "1.25",

                    letterSpacing:
                        "0.12em",

                    color:
                        "#777",

                    whiteSpace:
                        "normal",

                    overflow:
                        "visible",

                    textOverflow:
                        "clip",

                    overflowWrap:
                        "normal",

                    wordBreak:
                        "normal",

                    textTransform:
                        "uppercase"
                }
            );

            return;
        }

        [
            "fontFamily",
            "fontSize",
            "fontWeight",
            "lineHeight",
            "letterSpacing",
            "color",
            "whiteSpace",
            "overflow",
            "textOverflow",
            "overflowWrap",
            "wordBreak",
            "textTransform"
        ].forEach(
            (property) => {
                element.style[
                    property
                    ] =
                    "";
            }
        );
    }


    // ==========================================================
    // GENERATED COVER
    // ==========================================================

    function createPlaceholderCover(
        book,
        title
    ) {
        const placeholder =
            document.createElement(
                "div"
            );

        placeholder.setAttribute(
            "data-book-placeholder",
            ""
        );

        const generatedCover =
            document.createElement(
                "div"
            );

        generatedCover.className =
            "fr-books-placeholder-cover";

        generatedCover.style.backgroundImage =
            `url("${GENERIC_COVER_IMAGE_URL}")`;

        generatedCover.style.backgroundSize =
            "cover";

        generatedCover.style.backgroundPosition =
            "center";

        generatedCover.style.backgroundRepeat =
            "no-repeat";

        const titleZone =
            document.createElement(
                "div"
            );

        titleZone.className =
            "fr-books-placeholder-titleZone";

        const titleElement =
            document.createElement(
                "div"
            );

        titleElement.className =
            "fr-books-placeholder-title";

        titleElement.setAttribute(
            "data-book-placeholder-title",
            ""
        );

        titleElement.textContent =
            title;

        const middle =
            document.createElement(
                "div"
            );

        middle.className =
            "fr-books-placeholder-middle";

        const badge =
            document.createElement(
                "div"
            );

        badge.className =
            "fr-books-placeholder-badge";

        badge.textContent =
            "IN PROGRESS";

        const author =
            document.createElement(
                "div"
            );

        author.className =
            "fr-books-placeholder-author";

        author.textContent =
            "TOM BEAVER";

        titleZone.appendChild(
            titleElement
        );

        middle.appendChild(
            badge
        );

        generatedCover.append(
            titleZone,
            middle,
            author
        );

        placeholder.appendChild(
            generatedCover
        );

        return {
            placeholder,
            titleElement
        };
    }


    function fitPlaceholderTitle(
        titleElement
    ) {
        if (
            !titleElement
        ) {
            return;
        }

        titleElement.style.fontSize =
            "";

        window.requestAnimationFrame(
            () => {
                if (
                    titleElement.offsetWidth <
                    1 ||
                    titleElement.offsetHeight <
                    1
                ) {
                    return;
                }

                let fontSize =
                    Number.parseFloat(
                        window
                            .getComputedStyle(
                                titleElement
                            )
                            .fontSize
                    );

                if (
                    !Number.isFinite(
                        fontSize
                    )
                ) {
                    return;
                }

                const minimumFontSize =
                    12;

                while (
                    fontSize >
                    minimumFontSize &&
                    (
                        titleElement.scrollHeight >
                        titleElement.clientHeight +
                        1 ||
                        titleElement.scrollWidth >
                        titleElement.clientWidth +
                        1
                    )
                    ) {
                    fontSize -=
                        0.5;

                    titleElement.style.fontSize =
                        `${fontSize}px`;
                }
            }
        );
    }


    function showPlaceholderCover(
        image,
        placeholder,
        titleElement
    ) {
        if (
            image
        ) {
            image.hidden =
                true;
        }

        placeholder.hidden =
            false;

        fitPlaceholderTitle(
            titleElement
        );
    }


    function showImageCover(
        image,
        placeholder
    ) {
        if (
            !image ||
            image.dataset.coverReady !==
            "true"
        ) {
            return;
        }

        image.hidden =
            false;

        placeholder.hidden =
            true;
    }


    // ==========================================================
    // HOME COVER / METADATA STATE
    // ==========================================================

    function setBookHoverPresentation(
        bookElement,
        isHoverMode
    ) {
        if (
            !bookElement
        ) {
            return;
        }

        const topMeta =
            bookElement.querySelector(
                ".fr-home-minimal-bookSlider-book__meta--top"
            );

        const metaTitle =
            bookElement.querySelector(
                ".fr-home-minimal-bookSlider-book__metaTitle"
            );

        const metaSubtitle =
            bookElement.querySelector(
                ".fr-home-minimal-bookSlider-book__metaSubtitle"
            );

        if (
            topMeta
        ) {
            topMeta.textContent =
                bookElement.dataset
                    .completionLabel ||
                "";
        }

        if (
            metaTitle
        ) {
            metaTitle.textContent =
                isHoverMode
                    ? (
                        bookElement.dataset
                            .workingTitle ||
                        ""
                    )
                    : (
                        bookElement.dataset
                            .permanentId ||
                        ""
                    );

            setPermanentIdPresentation(
                metaTitle,
                !isHoverMode
            );
        }

        if (
            metaSubtitle
        ) {
            if (
                isHoverMode
            ) {
                const subtitle =
                    bookElement.dataset
                        .subtitle ||
                    "";

                metaSubtitle.textContent =
                    subtitle;

                metaSubtitle.hidden =
                    !subtitle;
            } else {
                metaSubtitle.textContent =
                    "";

                metaSubtitle.hidden =
                    true;
            }
        }

        if (
            isHoverMode
        ) {
            /*
             * Override the inherited thumbnail variables on this
             * one book for the whole hover/focus state.
             */
            bookElement.style.setProperty(
                "--tb-thumbs-filter",
                "none"
            );

            bookElement.style.setProperty(
                "--tb-thumbs-opacity",
                "1"
            );

            bookElement.style.setProperty(
                "--tb-thumbs-active-filter",
                "none"
            );

            bookElement.style.setProperty(
                "--tb-thumbs-active-opacity",
                "1"
            );
        } else {
            [
                "--tb-thumbs-filter",
                "--tb-thumbs-opacity",
                "--tb-thumbs-active-filter",
                "--tb-thumbs-active-opacity"
            ].forEach(
                (property) => {
                    bookElement.style.removeProperty(
                        property
                    );
                }
            );
        }
    }


    function syncBookHoverPresentation(
        bookElement
    ) {
        if (
            !bookElement
        ) {
            return;
        }

        setBookHoverPresentation(
            bookElement,
            bookElement.matches(
                ":hover"
            ) ||
            document.activeElement ===
            bookElement
        );
    }


    // ==========================================================
    // CREATE BOOK
    // ==========================================================

    function createBookElement(
        book
    ) {
        const structuredMetadata =
            getStructuredMetadata(
                book
            );

        const imagePath =
            String(
                structuredMetadata.coverImage ||
                ""
            ).trim();

        const title =
            getWorkingTitle(
                book
            );

        const subtitle =
            String(
                structuredMetadata.subtitle ||
                ""
            ).trim();

        const completionPercentage =
            getCompletionPercentage(
                book,
                structuredMetadata
            );

        const completionLabel =
            completionPercentage ===
            null
                ? ""
                : `${completionPercentage}%`;

        const permanentId =
            getPermanentBookId(
                book
            );

        const recentlyWorkedOn =
            wasBookWorkedOnRecently(
                book.slug
            );

        const link =
            document.createElement(
                "a"
            );

        link.className =
            "fr-home-minimal-bookSlider-book";

        link.href =
            `/books/?book=${encodeURIComponent(
                book.slug
            )}`;

        link.setAttribute(
            "aria-label",
            `Open ${title}`
        );

        link.dataset.workingTitle =
            title;

        link.dataset.subtitle =
            subtitle;

        link.dataset.completionLabel =
            completionLabel;

        link.dataset.permanentId =
            permanentId;

        const topMeta =
            document.createElement(
                "div"
            );

        topMeta.className =
            "fr-home-minimal-bookSlider-book__meta " +
            "fr-home-minimal-bookSlider-book__meta--top";

        topMeta.textContent =
            completionLabel;

        topMeta.style.fontSize =
            "2rem";

        const cover =
            document.createElement(
                "div"
            );

        cover.className =
            "fr-home-minimal-bookSlider-book__cover";

        cover.style.position =
            "relative";

        const {
            placeholder,
            titleElement
        } =
            createPlaceholderCover(
                book,
                title
            );

        cover.appendChild(
            placeholder
        );

        if (
            imagePath
        ) {
            const image =
                document.createElement(
                    "img"
                );

            image.className =
                "fr-home-minimal-bookSlider-book__image";

            image.alt =
                `Cover of ${title}`;

            image.hidden =
                true;

            image.dataset.coverReady =
                "false";

            image.onload =
                () => {
                    image.dataset.coverReady =
                        "true";

                    showImageCover(
                        image,
                        placeholder
                    );

                    syncBookHoverPresentation(
                        link
                    );
                };

            image.onerror =
                () => {
                    image.dataset.coverReady =
                        "false";

                    showPlaceholderCover(
                        image,
                        placeholder,
                        titleElement
                    );
                };

            image.src =
                imagePath;

            cover.prepend(
                image
            );
        } else {
            showPlaceholderCover(
                null,
                placeholder,
                titleElement
            );
        }

        if (
            recentlyWorkedOn
        ) {
            cover.appendChild(
                createRecentWorkBadge()
            );
        }

        const bottomMeta =
            document.createElement(
                "div"
            );

        bottomMeta.className =
            "fr-home-minimal-bookSlider-book__meta " +
            "fr-home-minimal-bookSlider-book__meta--bottom";

        const metaTitle =
            document.createElement(
                "div"
            );

        metaTitle.className =
            "fr-home-minimal-bookSlider-book__metaTitle";

        metaTitle.textContent =
            permanentId;

        const metaSubtitle =
            document.createElement(
                "div"
            );

        metaSubtitle.className =
            "fr-home-minimal-bookSlider-book__metaSubtitle";

        metaSubtitle.textContent =
            "";

        metaSubtitle.hidden =
            true;

        bottomMeta.append(
            metaTitle,
            metaSubtitle
        );

        link.append(
            topMeta,
            cover,
            bottomMeta
        );

        setBookHoverPresentation(
            link,
            false
        );

        link.addEventListener(
            "pointerenter",
            () =>
                setBookHoverPresentation(
                    link,
                    true
                )
        );

        link.addEventListener(
            "pointerleave",
            () =>
                setBookHoverPresentation(
                    link,
                    document.activeElement ===
                    link
                )
        );

        link.addEventListener(
            "focus",
            () =>
                setBookHoverPresentation(
                    link,
                    true
                )
        );

        link.addEventListener(
            "blur",
            () =>
                setBookHoverPresentation(
                    link,
                    link.matches(
                        ":hover"
                    )
                )
        );

        window.requestAnimationFrame(
            () => {
                if (
                    !placeholder.hidden
                ) {
                    fitPlaceholderTitle(
                        titleElement
                    );
                }
            }
        );

        return link;
    }


    // ==========================================================
    // SLIDER GEOMETRY
    // ==========================================================

    function getBooks() {
        return Array.from(
            slider.querySelectorAll(
                ".fr-home-minimal-bookSlider-book"
            )
        );
    }


    function getTrackGap() {
        const styles =
            window.getComputedStyle(
                slider
            );

        const gap =
            Number.parseFloat(
                styles.columnGap ||
                styles.gap
            );

        return Number.isFinite(
            gap
        )
            ? gap
            : 0;
    }


    function getItemStride() {
        const firstBook =
            getBooks()[0];

        return firstBook
            ? firstBook
                .getBoundingClientRect()
                .width +
            getTrackGap()
            : 0;
    }


    function getVisibleBookCount() {
        const books =
            getBooks();

        if (
            !books.length
        ) {
            return 0;
        }

        const bookWidth =
            books[0]
                .getBoundingClientRect()
                .width;

        const gap =
            getTrackGap();

        const trackWidth =
            slider.clientWidth;

        if (
            bookWidth <=
            0 ||
            trackWidth <=
            0
        ) {
            return 1;
        }

        const count =
            Math.floor(
                (
                    trackWidth +
                    gap
                ) /
                (
                    bookWidth +
                    gap
                )
            );

        return Math.max(
            1,
            Math.min(
                count,
                books.length
            )
        );
    }


    function getMaximumScroll() {
        return Math.max(
            0,
            slider.scrollWidth -
            slider.clientWidth
        );
    }


    function isAtBeginning() {
        return slider.scrollLeft <=
            EDGE_TOLERANCE;
    }


    function isAtEnd() {
        return slider.scrollLeft >=
            getMaximumScroll() -
            EDGE_TOLERANCE;
    }


    function updateArrowState() {
        const canScroll =
            getMaximumScroll() >
            EDGE_TOLERANCE;

        if (
            previousButton
        ) {
            previousButton.disabled =
                !canScroll ||
                isAtBeginning();
        }

        if (
            nextButton
        ) {
            nextButton.disabled =
                !canScroll ||
                isAtEnd();
        }
    }


    function scrollGroup(
        direction
    ) {
        const visibleCount =
            getVisibleBookCount();

        const itemStride =
            getItemStride();

        if (
            visibleCount <
            1 ||
            itemStride <=
            0
        ) {
            return;
        }

        const distance =
            Math.max(
                1,
                visibleCount -
                1
            ) *
            itemStride;

        const maximumScroll =
            getMaximumScroll();

        const target =
            direction >
            0
                ? Math.min(
                    maximumScroll,
                    slider.scrollLeft +
                    distance
                )
                : Math.max(
                    0,
                    slider.scrollLeft -
                    distance
                );

        slider.scrollTo({
            left:
            target,

            behavior:
                "smooth"
        });
    }


    previousButton?.addEventListener(
        "click",
        () =>
            scrollGroup(
                -1
            )
    );


    nextButton?.addEventListener(
        "click",
        () =>
            scrollGroup(
                1
            )
    );


    slider.addEventListener(
        "scroll",
        updateArrowState,
        {
            passive:
                true
        }
    );


    // ==========================================================
    // RENDER
    // ==========================================================

    function render() {
        slider.replaceChildren();

        [
            ...catalog.getBooks()
        ]
            .sort(
                compareBooksByProgress
            )
            .forEach(
                (book) =>
                    slider.appendChild(
                        createBookElement(
                            book
                        )
                    )
            );

        slider.scrollLeft =
            0;

        window.requestAnimationFrame(
            () => {
                updateArrowState();

                slider
                    .querySelectorAll(
                        "[data-book-placeholder]:not([hidden]) " +
                        "[data-book-placeholder-title]"
                    )
                    .forEach(
                        fitPlaceholderTitle
                    );
            }
        );
    }


    // ==========================================================
    // RESIZE
    // ==========================================================

    let resizeFrame =
        null;


    function handleResize() {
        if (
            resizeFrame !==
            null
        ) {
            window.cancelAnimationFrame(
                resizeFrame
            );
        }

        resizeFrame =
            window.requestAnimationFrame(
                () => {
                    resizeFrame =
                        null;

                    const maximumScroll =
                        getMaximumScroll();

                    if (
                        slider.scrollLeft >
                        maximumScroll
                    ) {
                        slider.scrollTo({
                            left:
                            maximumScroll,

                            behavior:
                                "auto"
                        });
                    }

                    slider
                        .querySelectorAll(
                            "[data-book-placeholder]:not([hidden]) " +
                            "[data-book-placeholder-title]"
                        )
                        .forEach(
                            fitPlaceholderTitle
                        );

                    updateArrowState();
                }
            );
    }


    window.addEventListener(
        "resize",
        handleResize
    );


    if (
        "ResizeObserver" in
        window
    ) {
        const resizeObserver =
            new ResizeObserver(
                handleResize
            );

        resizeObserver.observe(
            slider
        );
    }


    // ==========================================================
    // INITIALIZE
    // ==========================================================

    catalog.ready.then(
        render
    );

})();
